<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : appViewModal}" id="app-view-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <h2 class="title">신청 정보 조회</h2>
      </div>
      <div class="modal-body-container ht-full" ref="modalBody">
        <div class="tab-wid-full tab-container-full">
          <div class="tab-head">
            <div class="tab-menu-wrap" role="tablist">
              <button type="button" class="tab-menu" role="tab" :aria-selected="showTab === 'resumeInfo'" :class="{ 'is-active' : showTab === 'resumeInfo' }" data-tab="resumeInfo" @click="changeTab('resumeInfo')">
                기본정보
                <span class="sr-only" v-if="showTab === 'resumeInfo'">선택됨</span>
              </button>
              <button type="button" class="tab-menu" role="tab" :aria-selected="showTab === 'subInfo'" :class="{ 'is-active' : showTab === 'subInfo' }" data-tab="subInfo" @click="changeTab('subInfo')">
                추가 입력 사항
                <span class="sr-only" v-if="showTab === 'subInfo'">선택됨</span>
              </button>
            </div>
          </div>
          <div class="tab-content__wrap">
            <div class="tab-content" :class="{ 'is-active' : showTab === 'resumeInfo' }" id="resumeInfo">
              <div class="">
                <h3 class="section-title mt-40" style="border-bottom: none;padding-bottom: 0px;">신청번호 : {{ appInfo.APP_NO }}</h3>
                <h3 class="section-title mt-40">{{ appInfo.APPLCNT_NM }} <span>{{ genderLabel }} | {{ appInfo.birthdeYear }}년({{ getAge }}세)</span></h3>
                <div class="table-wrap border-top-none mt-0">
                  <table class="table-body-only">
                    <caption>신청자 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">휴대<br class="mo-only">전화번호</th>
                        <td>{{ appInfo.HP_1 }}-{{ appInfo.HP_2 }}-{{ appInfo.HP_3 }}</td>
                      </tr>
                      <tr>
                        <th scope="row">이메일</th>
                        <td>{{ appInfo.EMAIL }}</td>
                      </tr>
                      <tr>
                        <th scope="row">비상<br class="mo-only">연락처</th>
                        <td>{{ appInfo.TELS }}</td>
                      </tr>
                      <tr>
                        <th scope="row">주소</th>
                        <td>{{ appInfo.ADDRS }}<br>{{ appInfo.ADDR_DTL }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">학력사항 기본정보</h3>
                <div class="table-wrap border-top-none mt-0">
                  <table class="table-body-only">
                    <caption>학력사항 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">최종학력</th>
                        <td>{{ appInfo.LAST_EDULV_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">
                          최종학력<br>졸업여부
                        </th>
                        <td>{{ appInfo.LAST_EDULV_STAT_NM }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">학교 및 전공 정보</h3>
                <div class="table-wrap border-top-none mt-0" v-for="(school, index) in schoolInfoList" :key="index">
                  <table class="table-body-only">
                    <caption>학교 및 전공 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">학교명</th>
                        <td>{{ school.SCHOOL_NAME }}</td>
                      </tr>
                      <tr>
                        <th scope="row">학력구분</th>
                        <td>{{ school.SCHOOL_TYPE_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">전공</th>
                        <td>{{ school.MAJOR }}</td>
                      </tr>
                      <tr>
                        <th scope="row">부전공</th>
                        <td>{{ school.SUB_MAJOR }}</td>
                      </tr>
                      <tr>
                        <th scope="row">졸업여부</th>
                        <td>{{ school.GRADUATION_STATUS_NM }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">경력사항</h3>
                <div class="table-wrap border-top-none mt-0" v-for="(career, index) in careerInfoList" :key="index">
                  <table class="table-body-only">
                    <caption>경력사항 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">회사<br class="mo-only">(단체)명</th>
                        <td>{{ career.COMPNM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">근무<br class="mo-only">(활동)기간</th>
                        <td>{{ career.CARR_PERIOD }}</td>
                      </tr>
                      <tr>
                        <th scope="row">직위</th>
                        <td>{{ career.POS }}</td>
                      </tr>
                      <tr>
                        <th scope="row">담당업무</th>
                        <td>{{ career.RESBIZ }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">보유 자격증/면허증</h3>
                <div class="table-wrap border-top-none mt-0" v-for="(qualification, index) in qualificationList" :key="index">
                  <table class="table-body-only">
                    <caption>보유 자격증/면허증 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">자격증/<br class="mo-only">면허증</th>
                        <td>{{ qualification.QUANM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">발행처/<br class="mo-only">발행기관</th>
                        <td>{{ qualification.PUBLIC_ORG }}</td>
                      </tr>
                      <tr>
                        <th scope="row">합격구분</th>
                        <td>{{ qualification.PASSCD_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">취득년도</th>
                        <td>{{ qualification.GETDATE }}년</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">OA작성능력</h3>
                <div class="table-wrap border-top-none mt-0" v-for="(oaskill, index) in oaSkillsList" :key="index">
                  <table class="table-body-only">
                    <caption>OA작성능력 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">문서작성<br>(한글/MS-Word)</th>
                        <td>{{ oaskill.DOCSKL_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">스프레드시트<br>(Excel)</th>
                        <td>{{ oaskill.SHETSKL_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">프리젠테이션<br>(PowerPoint)</th>
                        <td>{{ oaskill.PPTSKL_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">인터넷<br>(정보검색/outlook)</th>
                        <td>{{ oaskill.INTERSKL_NM }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">주요활동/사회공헌</h3>
                <div class="table-wrap border-top-none mt-0" v-for="activity in activityList" :key="activity.seq">
                  <table class="table-body-only">
                    <caption>주요활동/사회공헌 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">활동구분</th>
                        <td>{{ activity.ACT_CD_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">활동기간</th>
                        <td>{{ activity.ACTPER_ST }} - {{ activity.ACTPER_ED }}</td>
                      </tr>
                      <tr>
                        <th scope="row">기관/장소</th>
                        <td>{{ activity.COMPNM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">활동내용</th>
                        <td>{{ activity.ACT_DESC }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">희망 활동(근무) 조건</h3>
                <div class="table-wrap border-top-none mt-0">
                  <table class="table-body-only">
                    <caption>희망 활동(근무) 조건 정보 테이블</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">업직종</th>
                        <td>{{ appInfo.PREF_OCCUPATION_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">희망시급</th>
                        <td>{{ getSalaryNm(appInfo.HOPE_WAGE) }}</td>
                      </tr>
                      <tr>
                        <th scope="row">고용형태</th>
                        <td>{{ appInfo.PREF_EMPLOYMENT_TYPE_NM }}</td>
                      </tr>
                      <tr>
                        <th scope="row">희망근무지역</th>
                        <td>{{ appInfo.HOPE_WORK_REGION_NM }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">자기소개서</h3>
                <div class="table-wrap border-top-none mt-0">
                  <table class="table-body-only">
                    <caption>자기소개서 표</caption>
                    <colgroup class="pc-cell">
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <div class="text-box-section resume-area" style="white-space: pre-line;" v-text="appInfo.SELFINTRO">
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">사업 참여이력</h3>
                <div class="table-wrap border-top-none" :class="{'mt-0' : index === 0}" v-for="(jobActHistory, index) in jobActHistoryList" :key="index">
                  <table class="table-body-only">
                    <caption>사업 참여이력 테이블 {{ index + 1 }}</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row" colspan="2">
                          <div class="history-item">
                            <div class="history-item-num">{{ index + 1 }}</div>
                            <div class="history-item-subject">
                              {{ jobActHistory.bizCateName }} ({{ jobActHistory.bizYear }})
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">세부<br class="mo-only">사업명</th>
                        <td>{{ jobActHistory.detailBizName }}</td>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">공고명</th>
                        <td>{{ jobActHistory.annName }}</td>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">활동기간</th>
                        <td>{{ jobActHistory.actStartDate }} ~ {{ jobActHistory.actEndDate }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h3 class="section-title mt-40">교육 이수이력</h3>
                <div class="table-wrap border-top-none" :class="{'mt-0' : index === 0}" v-for="(educationHistory, index) in educationHistoryList" :key="index">
                  <table class="table-body-only">
                    <caption>교육 이수이력 테이블 {{ index + 1 }}</caption>
                    <colgroup class="pc-cell">
                      <col style="width: 160px;" />
                      <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                      <col style="width: 88px;" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row" colspan="2">
                          <div class="history-item">
                            <div class="history-item-num">{{ index + 1 }}</div>
                            <div class="history-item-subject">
                              {{ educationHistory.lectureName }}
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">기관</th>
                        <td>{{ educationHistory.orgName }}</td>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">
                          사업년도<br>(중분류)
                        </th>
                        <td>{{ educationHistory.termName }}</td>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">
                          소분류<br>(이수여부)
                        </th>
                        <td>{{ educationHistory.facultyName }}</td>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">
                          교육기간
                        </th>
                        <td>{{ educationHistory.educationPeriod }}</td>
                      </tr>
                      <tr>
                        <th scope="row" class="no-bg">
                          강사
                        </th>
                        <td>{{ educationHistory.instructorName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="tab-content" :class="{ 'is-active' : showTab === 'subInfo' }" id="subInfo" v-if="annKindType === 'JB'">
              <div class="border-line-box">
                <!-- JB 전용 필드들 -->
                <jb-specific-fields :app-info="appInfo" :is-disabled="isDisabled" />

                <!-- 희망 활동처 -->
                <wish-company-section
                  :wish-comp1="appInfo.WISH_ACTCOMP_1_NM"
                  :wish-comp2="appInfo.WISH_ACTCOMP_2_NM"
                  :wish-comp3="appInfo.WISH_ACTCOMP_3_NM"
                  :is-disabled="isDisabled"
                  placeholder="입력해 주세요."
                  title="희망 활동처"
                />

                <!-- 첨부파일 등록 -->
                <attachment-section :ann-kind-type="annKindType" :files="attachFileList" :is-disabled="isDisabled" v-if="attachFileList.length > 0"/>

                <!-- 추가 질문 리스트 -->
                <additional-questions
                  :questions="additionalInfoList"
                  :ann-kind-type="annKindType"
                  :is-disabled="isDisabled"
                  v-if="additionalInfoList.length > 0"
                />

                <!-- <div v-else class="empty-content-message-view" style="display: flex; justify-content: center; align-items: center; min-height: 200px; " >
                  <div style="font-size: 48px; color: #999; margin-bottom: 20px; opacity: 0.7;">
                    <i class="ico ico-info"></i>
                  </div>
                  <div style="font-size: 18px; color: #333; font-weight: 500; line-height: 1.5;">
                    이 공고는 추가 입력사항이 없는 공고입니다.
                  </div>
                </div> -->

                <!-- 공공마이데이터 -->
                <public-mydata-section :public-my-data-yn="publicMyDataYn" v-if="showPublicMyData"/>
              </div>
            </div>
            <div class="tab-content" :class="{ 'is-active' : showTab === 'subInfo' }" id="subInfo" v-else>
              <div class="border-line-box">
                <!-- IN 전용 필드들 -->
                <in-specific-fields :check-list-answers="checkListAnswers" :is-disabled="isDisabled" v-if="showCheckList"/>

                <!-- 희망 활동처 (특정 bizSe가 아닌 경우만) -->
                <wish-company-section
                  v-if="bizSe !== 'IN49008' && appInfo.WISH_ACTCOMP_1 !== null"
                  :wish-comp1="appInfo.WISH_ACTCOMP_1"
                  :wish-comp2="appInfo.WISH_ACTCOMP_2"
                  :wish-comp3="appInfo.WISH_ACTCOMP_3"
                  :is-disabled="isDisabled"
                  placeholder="입력해 주세요."
                  title="희망 활동처"
                />

                <!-- 첨부파일 등록 -->
                <attachment-section :ann-kind-type="annKindType" :files="attachFileList" :is-disabled="isDisabled" placeholder="파일이 없음" v-if="attachFileList.length > 0"/>

                <!-- 추가 질문 리스트 -->
                <additional-questions
                  :questions="additionalInfoList"
                  :ann-kind-type="annKindType"
                  :is-disabled="isDisabled"
                  v-if="additionalInfoList.length > 0"
                />

                <!-- 추가 입력 사항이 없음 -->
                <div v-if="bizSe === 'IN49008' && attachFileList.length === 0 && additionalInfoList.length === 0 && !showPublicMyData" class="empty-content-message" style="display: flex; justify-content: center; align-items: center; min-height: 200px; " >
                  <div style="font-size: 48px; color: #999; margin-bottom: 20px; opacity: 0.7;">
                    <i class="ico ico-info"></i>
                  </div>
                  <div style="font-size: 18px; color: #333; font-weight: 500; line-height: 1.5;">
                    이 공고는 추가 입력사항이 없는 공고입니다.
                  </div>
                </div>

                <!-- 공공마이데이터 -->
                <public-mydata-section :public-my-data-yn="publicMyDataYn" v-if="showPublicMyData"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          닫기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="modify" v-if="applicableYn == 'Y'">
          <i class="ico ico-pen-wt"></i>
          수정하기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
    <resume-list-modal :isActive="showResumeListModal" :appNo="appNo" @update:closeModal="closeResumeListModal" @updateIndbankNo="updateIndbankNo"></resume-list-modal>
  </div>
</template>

<script>
import Axios from 'axios';
import ResumeListModal from './ResumeList.vue';
import AttachmentSection from './AttachmentSection.vue';
import PublicMydataSection from './PublicMydataSection.vue';
import WishCompanySection from './WishCompanySection.vue';
import AdditionalQuestions from './AdditionalQuestions.vue';
import JbSpecificFields from './JbSpecificFields.vue';
import InSpecificFields from './InSpecificFields.vue';

const gender = {
  M: '남',
  F: '여',
};

export default {
  name: 'app-view-template',
  props: ['appViewModal', 'appNo', 'annNo', 'annKindType', 'mode', 'bizSe'],
  components: {
    ResumeListModal,
    AttachmentSection,
    PublicMydataSection,
    WishCompanySection,
    AdditionalQuestions,
    JbSpecificFields,
    InSpecificFields,
  },
  data() {
    return {
      applicableYn: 'N',
      appInfo: {},
      schoolInfoList: [],
      careerInfoList: [],
      qualificationList: [],
      oaSkillsList: [],
      activityList: [],
      preferenceInfo: {},
      jobActHistoryList: [],
      educationHistoryList: [],
      wishCompOptions: [],
      publicMyDataYn: [],
      wishActcompList: [],
      checkListAnswers: [
        { SEQ: 1, ANSWER: '', DTL_ANSWER_1: '', DTL_ANSWER_2: '' },
        { SEQ: 2, ANSWER: '', DTL_ANSWER_1: '', DTL_ANSWER_2: '' },
        { SEQ: 3, ANSWER: '', DTL_ANSWER_1: '', DTL_ANSWER_2: '' }
      ], // 체크리스트 답변 조회
      additionalInfoList: [], // 추가입력내용(질문+답변) 조회
      attachFileList: [], // 첨부파일 정보 조회
      codes: {},
      isShow: false,
      showTab: 'resumeInfo',
      isDisabled: true,
      showResumeListModal: false,
      showCheckList: false,
      showPublicMyData: false,
    };
  },
  watch: {
    appViewModal: {
      handler(newVal) {
        if (newVal) {
          this.getAppDetail();
          this.showTab = 'resumeInfo';
          this.$nextTick(() => {
            if (this.$refs.modalBody) {
              this.$refs.modalBody.scrollTop = 0;
            }
          });
        }
      },
    },
  },
  methods: {
    initializeData() {
      this.applicableYn = 'N';
      this.showTab = 'resumeInfo';
      this.isDisabled = true;
    },
    close() {
      this.initializeData();
      this.$emit('update:appViewModal', false);
    },
    closeResumeListModal() {
      this.showResumeListModal = false;
      this.getAppDetail();
    },
    modify() {
      if (this.showTab === 'resumeInfo') this.showResumeListModal = true;
      if (this.showTab === 'subInfo') {
        // 1. 필요한 데이터 전역 변수로 설정
        window.currentAnnNo = this.annNo;
        window.currentAppNo = this.appNo;
        window.currentbizSe = this.bizSe;

        // 2. 모달 활성화
        if (this.annKindType === 'JB') this.loadJBAdditionalModalContent();
        else this.openINAdditionalModal();
      }
    },
    openINAdditionalModal() {
      console.log('IN 추가 입력사항 모달 열기 시도');
      console.log('Props 정보:', {
        appNo: this.appNo,
        annNo: this.annNo,
        annKindType: this.annKindType,
        bizSe: this.bizSe
      });

      // AppView는 숨기고 modal004Job만 표시
      // this.appViewModal = false;

      // modal004Job 찾기
      const modal = document.getElementById('modal004Job');
      if (modal) {
        console.log('modal004Job 찾음');

        // 필요한 데이터 전역 변수로 설정
        window.currentAnnNo = this.annNo;
        window.currentAppNo = this.appNo;
        window.currentbizSe = this.bizSe;

        // 현재 AppView 모달 닫기
        // this.close();

        // modal004Job 열기
        modal.style.display = 'block';
        modal.style.visibility = 'visible';
        modal.style.opacity = '1';
        modal.classList.add('is-active');
        modal.style.zIndex = '9999';

        console.log('modal004Job 스타일 적용 완료');

        // IN용 추가 입력사항 데이터 로드 (필요한 경우)
        this.loadINAdditionalData();
      } else {
        console.error('modal004Job을 찾을 수 없습니다.');
        alert('추가 입력사항 모달을 찾을 수 없습니다.');
      }
    },

    /**
     * IN 타입 추가 입력사항 데이터 로드
     */
    loadINAdditionalData() {
      // loadJobAdditionalInfo 함수 호출 (사용자 요청사항)
      if (typeof window.loadJobAdditionalInfo === 'function') {
        setTimeout(() => window.loadJobAdditionalInfo(), 100);
        console.log('loadJobAdditionalInfo 함수 호출 완료');
      } else {
        console.warn('loadJobAdditionalInfo 함수를 찾을 수 없습니다.');
      }

      // 모달 닫기 이벤트 리스너 등록
      // this.setupModalCloseListener();
    },

    loadJBAdditionalModalContent() {
      const ann_no = $('#ANN_NO').val() || $('input[name="ANN_NO"]').val() || window.currentAnnNo || this.annNo;

      $.ajax({
        url: '/appAdditionalModifyModal',
        type: 'GET',
        data: {
          ANN_NO: ann_no
        },
        success: function(response) {
          $('#modal003JB').html(response);

          // 3단계 모달이 제대로 표시되도록 스타일 강제 적용
          const modal = document.getElementById('modal003JB');
          if (modal) {
            modal.style.display = 'block';
            modal.style.visibility = 'visible';
            modal.style.opacity = '1';
            modal.classList.add('is-active');

            // z-index 설정으로 최상위 레이어에 표시
            modal.style.zIndex = '9999';
          }

          // 추가 입력사항 정보 로드 (loadJobAdditionalInfo 함수 호출)
          const loadAdditionalData = () => {
            const containers = document.querySelectorAll('#modal003JB .sub-info-container, #modal003JB .attach-info-container');
            if (containers.length >= 1) { // 조건 완화: 1개 이상 컨테이너 존재하면 로드
              window.isLoadingAdditionalInfo = false;
              window.additionalInfoLoaded = false;

              if (typeof window.loadJobAdditionalInfo === 'function') {
                setTimeout(() => window.loadJobAdditionalInfo(), 100);
                setTimeout(() => {
                  if (window.restoreFormData && typeof window.restoreFormData === 'function') {
                    window.restoreFormData();
                  }
                }, 200);
              }
            } else {
              // 컨테이너가 아직 렌더링되지 않았으면 잠시 후 다시 시도
              setTimeout(loadAdditionalData, 100);
            }
          };

          loadAdditionalData();
          // 약간의 지연 후 로드 시작 (DOM 렌더링 완료 대기)
          // setTimeout(loadAdditionalData, 50);
        },
        error: function(xhr, status, error) {
          alert('추가 입력사항 단계를 불러오는데 실패했습니다.');
        }
      });
    },
    changeTab(id) {
      this.showTab = id;
    },
    getAppDetail() {
      let url = (this.annKindType === 'JB') ? `/api/jb/app/${this.appNo}/detail` : `/api/in/app/${this.appNo}/detail`;
      if (this.mode === 'comp') url = `/api/in/app/${this.appNo}/detailForCompany`;

      Axios.get(url).then((response) => {
        const data = response.data.data;
        const birthde = data.appInfo.BIRTHDE ? data.appInfo.BIRTHDE.split('-') : ['', '', ''];
        this.appInfo = {
          ...data.appInfo,
          birthdeYear: parseInt(birthde[0]) || 0,
          birthdeMt: parseInt(birthde[1]) || 0,
          birthdeDd: parseInt(birthde[2]) || 0,
        };
        this.schoolInfoList = data.schoolInfoList;
        this.careerInfoList = data.careerInfoList;
        this.qualificationList = data.qualificationList;
        this.oaSkillsList = data.oaSkillsList;
        this.activityList = data.activityList;
        this.applicableYn = data.applicableYn;
        this.wishActcompList = data.wishActcompList;
        this.checkListAnswers = data.checkListAnswers || this.checkListAnswers; // 체크리스트 답변 조회
        this.additionalInfoList = data.additionalInfoList; // 추가입력내용(질문+답변) 조회
        this.attachFileList = data.attachFileList; // 첨부파일 정보 조회
        this.educationHistoryList = data.educationHistoryList;
        this.jobActHistoryList = data.jobActHistoryList;
        this.bizSe = data.appInfo.BIZ_SE || this.bizSe;
        this.showCheckList = data.showCheckList;
        this.showPublicMyData = (data.publicMyDataYn === 'Y');
      }).catch((e) => {
        alert((e.response && e.response.data && e.response.data.message) || '오류가 발생했습니다.');
      });
    },
    isChecked(option, answers) {
      if (!answers || typeof answers !== 'string') return false;
      return answers.split(',').filter((answer) => answer === option).length > 0;
    },
    getOptions(options) {
      if (!options || typeof options !== 'string') return [];
      return options.split(',');
    },
    getResumeCodes() {
      Axios.get('/api/common-codes/resume-codes').then((response) => {
        this.codes = response.data;
      }).catch((e) => {
        alert((e.response && e.response.data && e.response.data.message) || '오류가 발생했습니다.');
      });
    },
    getSkillsNm(code) {
      if (!this.codes.oaSkills) return '';
      let name = '';
      this.codes.oaSkills.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getPassNm(code) {
      if (!this.codes.passingSteps) return '';
      let name = '';
      this.codes.passingSteps.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getSalaryNm(code) {
      if (!this.codes.desiredSalaryRanges) return '';
      let name = '';
      this.codes.desiredSalaryRanges.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getWorkRegionNm(codes) {
      if (!this.codes.desiredWorkRegions || !codes || typeof codes !== 'string') return '';
      const name = [];
      codes.split(',').forEach((code) => {
        this.codes.desiredWorkRegions.forEach((item) => {
          if (item.code === code) name.push(item.name);
        });
      });
      return (name.length > 0) ? name.join(',') : '';
    },
    getEmploymentTypeNm(code) {
      if (!this.codes.desiredEmploymentTypeCodes) return '';
      let name = '';
      this.codes.desiredEmploymentTypeCodes.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getActNm(code) {
      if (!this.codes.activities) return '';
      let name = '';
      this.codes.activities.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    getOccupationNm(code) {
      if (!this.codes.desiredOccupationCodes) return '';
      let name = '';
      this.codes.desiredOccupationCodes.forEach((item) => {
        if (item.code === code) name = item.name;
      });
      return name;
    },
    updateIndbankNo(indbankNo) {
      const url = (this.annKindType === 'JB')
        ? `/api/jb/app/${this.appNo}/updateResume?indbankNo=${indbankNo}`
        : `/api/in/app/${this.appNo}/updateResume?indbankNo=${indbankNo}`;
      Axios.post(url).then((res) => {
        if (res.data.success === "U") {
          alert("신청 이력서가 수정되었습니다.");
          this.closeResumeListModal();
        }
      }).catch((e) => {
        alert((e.response && e.response.data && e.response.data.message) || '오류가 발생했습니다.');
      });
    },
  },
  computed: {
    genderLabel() {
      return gender[this.appInfo.GENDER];
    },
    getAge() {
      const today = new Date();

      // 숫자 타입 확인
      if (!this.appInfo.birthdeYear || !this.appInfo.birthdeMt || !this.appInfo.birthdeDd) {
        return 0;
      }

      let age = today.getFullYear() - this.appInfo.birthdeYear;
      const monthDifference = today.getMonth() + 1 - this.appInfo.birthdeMt; // getMonth()는 0부터 시작
      if (monthDifference < 0
        || (monthDifference === 0 && today.getDate() < this.appInfo.birthdeDd)) {
        age -= 1;
      }
      return age;
    },
    // safeCheckListAnswers() {
    //   return this.checkListAnswers.length >= 3 ? this.checkListAnswers : [
    //     { SEQ: 1, ANSWER: '', DTL_ANSWER_1: '', DTL_ANSWER_2: '' },
    //     { SEQ: 2, ANSWER: '', DTL_ANSWER_1: '', DTL_ANSWER_2: '' },
    //     { SEQ: 3, ANSWER: '', DTL_ANSWER_1: '', DTL_ANSWER_2: '' }
    //   ];
    // },
  },
  mounted() {
    this.getResumeCodes();
    this.isShow = this.appViewModal;
  },
};
</script>



// WEBPACK FOOTER //
// AppView.vue?1ae3364c